
export const PFIS = "/api/folders/:folder/pfi"
export const PFI = "/api/folders/:folder/pfi/:param"
export const PFI_SETTING = "/api/folders/:folder/setting-pfi/:param"

export const PFI_ACTIVATE = "/api/folders/:folder/pfi/:param/activate"
export const PFI_DEACTIVATE = "/api/folders/:folder/pfi/:param/deactivate"
export const PFI_DELETE = "/api/folders/:folder/pfi/:param/delete"